module.exports = __webpack_public_path__ + "img/baht-red.30b92995.png";